import React from "react";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import Card from "components/ui/DeprecatedCard";
import { LargeSpacer } from "components/ui/VerticalSpacers";
import { validationSchema } from "./userAuth.module.js";
import { UserAuthForm } from "./UserAuthForm.js";
import { useAPI } from "components/hooks/useAPI";

// https://wikihub.berkeley.edu/display/SIS/CalCentral+New+User+Auths+Card
export function NewUserAuthCard() {
  const api = useAPI();

  // const csrfToken = useCSRFToken();
  const navigate = useNavigate();
  const initialValues = {
    uid: "",
    is_active: true,
    is_viewer: false,
    is_author: false,
    is_superuser: false,
  };

  const onSubmit = async (values, { setErrors }) => {
    const res = await api.auths.create(values);
    const data = await res.json();

    if (res.ok) {
      navigate(`/user_auths/${data.id}/edit`);
    } else if (res.status === 422) {
      setErrors(data);
    }
  };

  return (
    <Card title="New User Auth" data-testid="new-user-auth">
      <LargeSpacer />
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        <UserAuthForm />
      </Formik>
    </Card>
  );
}
NewUserAuthCard.displayName = "NewUserAuth";
